import React from 'react';
import {
  Typography,
  Box,
  List,
  ListItemText,
  ListItemIcon,
  Skeleton,
  TextField,
  InputAdornment,
} from '@mui/material';
import { FiSearch } from 'react-icons/fi';
import { LeagueItem } from '../../styles';

const LeaguesListSkeleton: React.FC = () => {
  // Criar um array com 10 itens vazios para renderizar 10 skeletons
  const skeletonItems = Array(7).fill(null);

  return (
    <Box component="section" aria-label="Competições">
      <Typography variant="h6" gutterBottom>
        <Skeleton width="60%" />
      </Typography>

      <TextField
        placeholder="Buscar liga..."
        size="small"
        fullWidth
        disabled
        sx={{ mb: 2 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FiSearch />
            </InputAdornment>
          ),
        }}
      />

      <List disablePadding>
        {skeletonItems.map((_, index) => (
          <LeagueItem 
            key={index} 
            disablePadding
            sx={{ py: 0.5 }}
          >
            <ListItemIcon>
              <Skeleton variant="circular" width={24} height={24} />
            </ListItemIcon>
            <ListItemText 
              primary={<Skeleton width="70%" />} 
              secondary={<Skeleton width="40%" />} 
            />
            <Skeleton variant="circular" width={24} height={24} />
          </LeagueItem>
        ))}
      </List>
    </Box>
  );
};

export default LeaguesListSkeleton; 